export const isEmptyArray = (items) => {
  return (
    Array.isArray(items) &&
    (items.length === 0 ||
      (items.length === 1 &&
        Object.values(items[0]).every(
          (v) => v === "" || v === 0 || v === null
        )))
  );
};
